import { useState, type ReactElement } from 'react';
import { Button } from '@ff-it/ui';
import { useModel } from 'components';
import { fetcher, useSessionScope } from 'services';
import { toast } from 'react-toastify';
import { useTable } from 'components/ControlledTable';

export default function AccountingSyncButton(): ReactElement | null {
  const { accounting_integration } = useSessionScope();
  const [loading, setLoading] = useState(false);
  const model = useModel();
  const { mutate } = useTable();
  if (!accounting_integration?.supports_list_sync) {
    return null;
  }

  const onClick = async () => {
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      await fetcher({
        url: `${model.endpoint}accounting_sync/`,
        method: 'POST',
      });
      toast.success('Synchronized successfully');
    } catch (_error: any) {
      toast.warn('Synchronization failed');
    }
    mutate();
    setLoading(false);
  };

  return (
    <Button mr="1" spin={loading} icon="book-open" disabled={loading} size="sm" variant="secondary" onClick={onClick}>
      Synchronize
    </Button>
  );
}
